import { useLocation, Link, useNavigate } from "react-router-dom";
import "./breadcrumb.style.scss";

const BreadcrumbComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();

    if (location.pathname === "/dashboard") return null;

    const pathnames: string[] = location.pathname.split("/").filter(x => x);
    const handleBack = () => {
        navigate(-1);
    }

    return (
        <nav className="breadcrumb_component">
            <ol>
                <button className="breadcrumb_back" onClick={handleBack}>
                    <span className="material-symbols-outlined" style={{ marginRight: "0.5rem" }}>
                        arrow_back
                    </span>

                </button>
                <li>
                    <Link to="/">Home</Link>
                </li>
                {pathnames.map((value, index) => {
                    const to = `/${pathnames.slice(0, index + 1).join("/")}`;
                    const isLast = index === pathnames.length - 1;

                    const labelMap: Record<string, string> = {
                        "ai-agents": "Scorecard",
                        "ai_agents": "Scorecard",    
                        "agents": "Team members",                  };
                
                    const label = labelMap[value] || decodeURIComponent(value);
                

                    return (
                        <li key={to}>
                            {isLast ? (
                                <span className="breadcrumb_active">{label}</span>
                            ) : (
                                <Link to={to}>{label}</Link>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};

export default BreadcrumbComponent;
